/* PORTFOLIO MUTATIONS */
export const importPortfolio = /* GraphQL */ `
mutation importPortfolio($filePath: String!, $name: String!) {
  importPortfolio(filePath: $filePath, name: $name) {
    portfolio {
      name
      id
    }
    message {
      message
      type
      row
    }
  }
}
`

export const portfolioUpdateMonitoring = /* GraphQL */ `
  mutation UpdatePortfolio(
    $input: UpdatePortfolioInput!
    $condition: ModelPortfolioConditionInput
  ) {
    updatePortfolio(input: $input, condition: $condition) {
      id
      name
      deactivateFinAlert
    }
  }
`
export const portfolioUpdateName = /* GraphQL */ `
  mutation UpdatePortfolio(
    $input: UpdatePortfolioInput!
    $condition: ModelPortfolioConditionInput
  ) {
    updatePortfolio(input: $input, condition: $condition) {
      id
      name
    }
  }
`

export const portfolioTransactionEdit = /* GraphQL */ `
  mutation PortfolioTransactionEdit($input: PortfolioTransactionEditInput) {
    portfolioTransactionEdit(input: $input) {
      isValid
      cause
      cashDeficit
    }
  }
`

export const portfolioTransactionDelete = /* GraphQL */ `
  mutation PortfolioTransactionDelete($input: PortfolioTransactionDeleteInput) {
    portfolioTransactionDelete(input: $input) {
      isValid
      cause
    }
  }
`

export const deletePortfolioNested = /* GraphQL */ `
  mutation DeletePortfolioNested($id: ID!) {
    deletePortfolioNested(id: $id) {
      id
      name
    }
  }`

export const portfolioUpdateShareUniverse = /* GraphQL */ `
  mutation UpdatePortfolioShareUniverse(
    $input: UpdatePortfolioInput!
  ) {
    updatePortfolio(input: $input) {
      id
      name
    }
  }`

export const deletePortfolioShareEntry = /* GraphQL */ `
  mutation PortfolioShareEntryDelete($portfolioId: ID!, $instrumentId: ID!) {
    portfolioShareEntryDelete(
      portfolioId: $portfolioId
      instrumentId: $instrumentId
    ) {
      portfolio{
        id
      }
      isValid
      cause
    }
  }
`

export const deletePortfolioEtfEntry = /* GraphQL */ `
  mutation PortfolioEtfEntryDelete($portfolioId: ID!, $instrumentId: ID!) {
    portfolioEtfEntryDelete(
      portfolioId: $portfolioId
      instrumentId: $instrumentId
    ) {
      portfolio{
        id
      }
      isValid
      cause
    }
  }
`

export const portfolioCashPayIn = /* GraphQL */ `
  mutation PortfolioCashPayIn($portfolioId: ID!, $cashAmount: Float!, $dateAdded: AWSDateTime!) {
    portfolioCashPayIn(portfolioId: $portfolioId, cashAmount: $cashAmount, dateAdded: $dateAdded) {
      id
      cash
    }
  }
`

export const portfolioCashPayOut = /* GraphQL */ `
  mutation PortfolioCashPayOut($portfolioId: ID!, $cashAmount: Float!, $dateAdded: AWSDateTime!) {
    portfolioCashPayOut(portfolioId: $portfolioId, cashAmount: $cashAmount, dateAdded: $dateAdded) {
      id
      cash
    }
  }
`


export const portfolioTransactionBuy = /* GraphQL */ `
  mutation PortfolioTransactionBuy($input: PortfolioTransactionInput) {
    portfolioTransactionBuy(input: $input) {
      id
    }
  }
`
export const portfolioTransactionSell = /* GraphQL */ `
  mutation PortfolioTransactionSell($input: PortfolioTransactionInput) {
    portfolioTransactionSell(input: $input) {
      id
    }
  }
`
export const portfolioTransactionDividend = /* GraphQL */ `
  mutation portfolioTransactionDividend($portfolioId: ID!, $instrumentId: ID, $dps: Float!, $dateAdded: AWSDateTime!) {
    portfolioTransactionDividend(portfolioId: $portfolioId, instrumentId: $instrumentId, dps: $dps, dateAdded: $dateAdded) {
      id
    }
  }
`

export const updatePortfolioStrategy = /* GraphQL */ `
    mutation UpdatePortfolio(
      $input: UpdatePortfolioInput!
      $condition: ModelPortfolioConditionInput
    ) {
      updatePortfolio(input: $input, condition: $condition) {
        id
      }
    }
`

export const exportPortfolio = /* GraphQL */ `
    mutation ExportPortfolio(
      $portfolioId: ID!
      $format: FileFormat!
    ) {
      exportPortfolio(portfolioId: $portfolioId, format: $format)
    }
`

export const getStrategyShareDistribution = /* GraphQL */ `
    query EetStrategyShareDistribution(
      $strategy: String!
    ) {
      getStrategyShareDistribution(strategy: $strategy)
    }
`

/* SPEAKER MUTATIONS */

export const updateSpeakerMessageReadAt = /* GraphQL */ `
  mutation updateSpeakerMessageReadAt(
    $id: ID!
    $now: AWSDateTime!
    $createdAt: AWSDateTime!
    $status: MessageStatus!
  ) {
    updateSpeakerMessageRecipient(input: {id: $id, readAt: $now, createdAt: $createdAt, status: $status})
    {
      id
      owner
      createdAt
      receivedAt
      readAt
      status
      message {
        id
        broadcastMessage
        type
        title
        text
        status
        createdAt
      }
    }
  }`

export const updateSpeakerMessageReceived = /* GraphQL */ `
  mutation updateSpeakerMessageReceived(
    $id: ID!
    $now: AWSDateTime!
  ) {
    updateSpeakerMessageRecipient(input: {id: $id, receivedAt: $now})
    {id}
  }`

export const updateSpeakerMessageApproved = /* GraphQL */ `
  mutation updateSpeakerMessage(
    $id: ID!
    $approved: Boolean!
    $status: String!
  ) {
    gr_updateSpeakerMessage(input: {id: $id, approved: $approved, status: $status})
    {id
     approved
    }
  }`

export const createSpeakerMessage = /* GraphQL */ `
  mutation CreateSpeakerMessage(
    $input: CreateSpeakerMessageInput!
  ) {
    gr_createSpeakerMessage(input: $input) {
      id
      broadcastMessage
      type
      title
      text
      approvalNeeded
      approved
      allowComments
      status
      displayUntil
    }
  }
`
export const updateSpeakerMessage = /* GraphQL */ `
  mutation UpdateSpeakerMessage(
    $input: UpdateSpeakerMessageInput!
  ) {
    gr_updateSpeakerMessage(input: $input) {
      id
      broadcastMessage
      type
      title
      text
      approvalNeeded
      approved
      allowComments
      status
      displayUntil
    }
  }
`

/* WATCHLISTS MUTATIONS */

export const createWatchlist = /* GraphQL */ `
  mutation CreateWatchlist(
    $input: CreateWatchlistInput!
    $condition: ModelWatchlistConditionInput
  ) {
    createWatchlist(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      watched {
        items {
          watchlistId
          instrumentId
        }
      }
    }
  }
`

export const renameWatchlist = /* GraphQL */ `
  mutation UpdateWatchlist(
    $input: UpdateWatchlistInput!
    $condition: ModelWatchlistConditionInput
  ) {
    updateWatchlist(input: $input, condition: $condition) {
      id
      name
      updatedAt
    }
  }
`

export const deleteWatchlist = /* GraphQL */ `
  mutation DeleteWatchlist(
    $input: DeleteWatchlistInput!
    $condition: ModelWatchlistConditionInput
  ) {
    deleteWatchlist(input: $input, condition: $condition) {
      id
      name
    }
  }
`

export const addWatchlistEntry = /* GraphQL */ `
  mutation AddWatchlistEntry(
    $watchlistId: ID!
    $instrumentId: ID!
  ) {
    addWatchlistEntry(
      watchlistId: $watchlistId
      instrumentId: $instrumentId
    ) {
      watchlistId
      instrumentId
      alertActive
      upperLimit
      lowerLimit
      createdAt
      updatedAt
      owner
    }
  }
`

export const updateWatchlistEntry = /* GraphQL */ `
  mutation UpdateWatchlistEntry(
    $input: UpdateWatchlistEntryInput!
  ) {
    updateWatchlistEntry(input: $input) {
      watchlistId
      instrumentId
      alertActive
      upperLimit
      lowerLimit
      createdAt
      updatedAt
      owner
      exceeded{
        upperLimit
        lowerLimit
        price
        timestamp
      }
      share {
        assetClass
        close
        closeChange1D
        closeChangeAbsolute1D
        closeDate
        high
        id
        low
        name
        isin
        latestPrice {
          id
          price
          priceChange
          priceChangePercentage
          high
          low
          timestamp
          quality
        }
      }
      etf {
        assetClass
        close
        closeChange1D
        closeChangeAbsolute1D
        closeDate
        id
        name
        isin
        latestPrice {
          id
          price
          priceChange
          priceChangePercentage
          high
          low
          timestamp
          quality
        }
      }
    }
  }
`

export const deleteWatchlistEntry = /* GraphQL */ `
  mutation DeleteWatchlistEntry(
    $input: DeleteWatchlistEntryInput!
    $condition: ModelWatchlistEntryConditionInput
  ) {
    deleteWatchlistEntry(input: $input, condition: $condition) {
       watchlistId
       instrumentId
      share {
        id
        ric
        name
      }
      etf {
        id
        name
      }
    }
  }`

export const deleteWatchlistNested = /* GraphQL */ `
  mutation DeleteWatchlistNested($id: ID!) {
    deleteWatchlistNested(id: $id) {
      id
    }
  }`

/* SCREENER MUTATIONS */

export const renameScreener = /* GraphQL */ `
  mutation UpdateScreenerConfiguration(
    $input: UpdateScreenerConfigurationInput!
    $condition: ModelScreenerConfigurationConditionInput
  ) {
    updateScreenerConfiguration(input: $input, condition: $condition) {
      id
    }
  }
`

export const saveScreenerConfiguration = /* GraphQL */ `
  mutation SaveScreenerConfiguration($input: ScreenerConfigurationInput) {
    saveScreenerConfiguration(input: $input) {
      id
      name
    }
  }
`

export const deleteScreenerConfiguration = /* GraphQL */ `
  mutation DeleteScreenerConfiguration(
    $input: DeleteScreenerConfigurationInput!
    $condition: ModelScreenerConfigurationConditionInput
  ) {
    deleteScreenerConfiguration(input: $input, condition: $condition) {
      id
      name
    }
  }
`

export const updateScreenerHits = /* GraphQL */ `
  mutation UpdateScreenerConfiguration(
    $input: UpdateScreenerConfigurationInput!
    $condition: ModelScreenerConfigurationConditionInput
  ) {
    updateScreenerConfiguration(input: $input, condition: $condition) {
      id
    }
  }
`

/* ETF SCREENER MUTATIONS */

export const updateEtfScreenerConfiguration = /* GraphQL */ `
  mutation UpdateEtfScreenerConfiguration(
    $input: UpdateEtfScreenerConfigurationInput!
    $condition: ModelEtfScreenerConfigurationConditionInput
  ) {
    updateEtfScreenerConfiguration(input: $input, condition: $condition) {
      id
    }
  }
`

export const saveEtfScreenerConfiguration = /* GraphQL */ `
  mutation SaveEtfScreenerConfiguration($input: EtfScreenerConfigurationInput) {
    saveEtfScreenerConfiguration(input: $input) {
      id
      name
    }
  }
`

export const deleteEtfScreenerConfiguration = /* GraphQL */ `
  mutation DeleteEtfScreenerConfiguration(
    $input: DeleteEtfScreenerConfigurationInput!
    $condition: ModelEtfScreenerConfigurationConditionInput
  ) {
    deleteEtfScreenerConfiguration(input: $input, condition: $condition) {
      id
      name
    }
  }
`

/* AGBs MUTATIONS */

export const acceptDocs = `
mutation acceptGeneralTerms($input: AcceptGeneralTermsInput){
   acceptGeneralTerms(
    input: $input
  ) {
    success
  }
}
`

/* User MUTATIONS */
export const updateUserPersonData = /* GraphQL */ `
mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    title
    salutation
    lastname
    firstname
    dateOfBirth
    address {
      street
      streetNo
      city
      zipCode
      country
    }
  }
}
`

export const updateUserEmail = /* GraphQL */ `
mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    email
  }
}
`

export const updateUsername = /* GraphQL */ `
mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    username
  }
}
`

export const registerUser = /* GraphQL */ `
mutation registerUser(
    $email: String!
) {
  registerUser(
    email: $email
  ) {
    email
  }
}
`

export const createUserDocument = /* GraphQL */ `
mutation createUserDocument (
    $input: CreateUserDocumentInput!
) {
  createUserDocument(input: $input) {
    fileName
  }
}
`

export const updateUserAcceptedDocs = /* GraphQL */ `
mutation updateUserAcceptedDocs(
  $input: UpdateUserInput!
) {
  updateUser(input: $input) {
    acceptedGeneralTerms {
      items {
        acceptedAt
        createdAt
        documentId
        owner
        updatedAt
        userId
        version
      }
    }
  }
}
`
export const updateUserOnboarding = /* GraphQL */ `
mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    onboarding
  }
}
`

export const updateUserArchetype = /* GraphQL */ `
mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    archetypeUpdatedAt
    archetype {
      id
      title
      img
      scene
      animation
      confirmationText
      shortDescription
      description
      matrixCode
      alternativeMatrixCodes
      classification {
        investmentObjective
        investmentHorizon
        attitudeToRisk
        levelOfKnowledge
        timeIntensity
        activeLevel
      }
      assetAllocation {
        name
        percentage
      }
      sortOrder
      createdAt
      updatedAt
      mainStrategyShare {
        id
        name
        description
        riskCategories
        communityRanking
        approach
        ruleDescription
        rules
        createdAt
        updatedAt
      }
      shareStrategyModels {
        nextToken
      }
      etfStrategyModels {
        nextToken
      }
    }
  }
}
`

export const updateUserProfileImage = /* GraphQL */ `
mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    image
  }
}
`

export const updateUserNewsletterSubscription = /* GraphQL */ `
  mutation updateUserNewsletterSubscription(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition){
      id
      newsletter
    }
  }
`
export const resendConfirmationLink = /* GraphQL */ `
  mutation ResendConfirmationLink($baseURL: String!, $token: String!) {
    resendConfirmationLink(baseURL: $baseURL, token: $token)
  }
`
export const confirmNewsletterUser = /* GraphQL */ `
  mutation ConfirmNewsletterUser($token: String!) {
    confirmNewsletterUser(token: $token)
  }
`
export const unregisterNewsletterUser = /* GraphQL */ `
  mutation UnregisterNewsletterUser($token: String!) {
    unregisterNewsletterUser(token: $token)
  }
`
export const unregisterNewsletterUserRequest = /* GraphQL */ `
  mutation UnregisterNewsletterUserRequest($baseURL: String!, $email: String!) {
    unregisterNewsletterUserRequest(baseURL: $baseURL, email: $email)
  }
`

export const updateSystemStatus = /* GraphQL */ `
  mutation updateSystemStatus($id: ID!, $status: String!) {
    gr_updateSystemStatus(input: {id: $id, status: $status}) {
      id
      status
    }
  }
`

/* ACTIVE / INACTIVE status mutations */

export const itemInactiveStatus = /* GraphQL */ `
  mutation ItemInactiveStatus($featureId: String!, $itemId: ID!, $newStatus: Boolean!) {
    setItemInactive(featureId: $featureId, itemId: $itemId, value: $newStatus){
      itemId inactive
    }
  }
`
